import { useMutation } from '@tanstack/react-query';

import { uploadFile } from '@services/document-signer/document-signer.service';

export function useUploadFile(accessToken: string) {
  return useMutation({
    mutationFn: (file: File) => uploadFile(file, accessToken),
  });
}
